export default __webpack_public_path__ + "static/media/first.2f34ac71.svg";